import { Link } from 'react-router-dom'

const TopHeader = () => {
  return (
    <div className='top-header'>
      <Link to={`/`}>
        <img src="/logo.jpg" width="100" height="100" alt="Ministerstwo Klimatu i Środowiska" className="logo" />
      </Link>
      <div className="header-text">
        <span>Uwaga: Archiwalny wykaz PDWD</span>
      </div>
    </div>
  )
}

export default TopHeader